<section>
  <header class="collapsible-item__header">
    <div class="collapsible-item__header-icon" (click)="toggle()">
      <cigna-icon-triangle
        size="medium"
        color="blue"
        [direction]="expanded ? 'south' : 'east'"
      ></cigna-icon-triangle>
    </div>
    <button
      style="padding: 0"
      cignaButton="link"
      class="collapsible-item__header-link"
      type="button"
      [class.active]="expanded"
      (click)="toggle()"
      data-test="cg-collapsible-item-header-text"
    >
      {{ headerText }}
    </button>
    <div class="collapsible-item__header-action">
      <button
        style="padding: 0"
        cignaButton="link"
        type="button"
        (click)="headerAction.emit($event)"
      >
        {{ actionText }}
      </button>
    </div>
  </header>
  <div *ngIf="expanded" class="collapsible-item__content">
    <ng-content></ng-content>
  </div>
</section>
